"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flickity_1 = __importDefault(require("flickity"));
// I do not know why but actualy typing args correctly causes problems. So it is unknown
// then typecast to the right object at the start of the block
exports.default = (args) => {
    return {
        play: () => { },
        pause: () => { },
        init() {
            const elem = this.$el.querySelector("ul");
            if (elem) {
                let requestId;
                if (elem.childNodes.length > 3) {
                    this.flickty = new flickity_1.default(elem, {
                        cellAlign: "left",
                        contain: true,
                        wrapAround: true,
                        prevNextButtons: false,
                        pageDots: false,
                        imagesLoaded: true,
                    });
                    elem.querySelectorAll("li").forEach(el => {
                        el.classList.add("h-full");
                    });
                    if (this.flickty) {
                        // @ts-ignore
                        this.flickty.x = 0;
                        // Start the marquee animation
                        // Main function that 'plays' the marquee.
                        this.play = () => {
                            // @ts-ignore
                            this.flickty.x = this.flickty.x - 1;
                            // @ts-ignore
                            this.flickty.settle(this.flickty.x);
                            requestId = window.requestAnimationFrame(this.play);
                        };
                        this.play();
                        // Main function to cancel the animation.
                        this.pause = () => {
                            if (requestId) {
                                window.cancelAnimationFrame(requestId);
                                requestId = undefined;
                            }
                        };
                        // Pause on mouse over / focusin
                        elem.addEventListener("mouseover", this.pause, false);
                        elem.addEventListener("focusin", this.pause, false);
                        // Unpause on mouse out / focusout
                        elem.addEventListener("mouseout", this.play, false);
                        elem.addEventListener("focusout", this.play, false);
                    }
                }
            }
        },
        autoPlay: true,
        toggle() {
            if (this.flickty) {
                if (this.autoPlay) {
                    this.pause();
                }
                else {
                    this.play();
                }
                this.autoPlay = !this.autoPlay;
            }
        },
    };
};
